/* This file was generated automatically. Do not edit manually. */

export enum ResourceCategoryType {
    Room = 'Room',
    Bed = 'Bed',
    Dorm = 'Dorm',
    Apartment = 'Apartment',
    Suite = 'Suite',
    Villa = 'Villa',
    Site = 'Site',
    Office = 'Office',
    MeetingRoom = 'MeetingRoom',
    ParkingSpot = 'ParkingSpot',
    Desk = 'Desk',
    TeamArea = 'TeamArea',
    Membership = 'Membership',
    Tent = 'Tent',
    CaravanOrRV = 'CaravanOrRV',
    UnequippedCampsite = 'UnequippedCampsite',
    Bike = 'Bike',
    ExtraBed = 'ExtraBed',
    Cot = 'Cot',
    Crib = 'Crib',
    ConferenceRoom = 'ConferenceRoom',
    Rooftop = 'Rooftop',
    Garden = 'Garden',
    Restaurant = 'Restaurant',
    Amphitheater = 'Amphitheater',
    PrivateSpaces = 'PrivateSpaces',
}
